/* eslint-disable global-require, no-undef */

import gui from '@/scripts/stage/globals/gui';
import camera from '@/scripts/stage/camera';
import scene from '@/scripts/stage/globals/scene';
import emitter from '@/scripts/stage/globals/emitter';
import renderer from '@/scripts/stage/globals/renderer';
import augmented from '@/scripts/stage/abstract/augmented';
import Blob from './modules/blob';

import {

  DEBUG,
  CONTAINER,
  STATS,
  ROTA_X,
  ROTA_Y,
  ROTA_Z,
  SET_ROTA_X,
  SET_ROTA_Y,
  SET_ROTA_Z,
  // DPI,

} from '@/scripts/stage/constants';

import './utils/stats';

const post = false;


let PostProcessing = null;

if (post) {
  PostProcessing = require('./postprocessing').default;
}


export default class World3D extends augmented {
  constructor() {
    super();

    this.addEvents();

    this.init();

    this.opts = {
      rota_x: ROTA_X,
      rota_y: ROTA_Y,
      rota_z: ROTA_Z,
    };

    if (DEBUG) {
      gui.add(this.opts, 'rota_x', -5, 5).step(0.01).onChange((val) => {
        SET_ROTA_X(val);
      }).listen();
      gui.add(this.opts, 'rota_y', -5, 5).step(0.01).onChange((val) => {
        SET_ROTA_Y(val);
      }).listen();
      gui.add(this.opts, 'rota_z', -5, 5).step(0.01).onChange((val) => {
        SET_ROTA_Z(val);
      }).listen();
    }
  }

  init() {
    this.blob = new Blob();

    this.blob.rotation.x = -0.5;

    scene.add(this.blob);

    if (STATS) {
      this.rendererStats = new THREEx.RendererStats();

      this.rendererStats.domElement.style.position = 'absolute';

      this.rendererStats.domElement.style.left = '0px';

      this.rendererStats.domElement.style.bottom = '0px';

      CONTAINER.appendChild(this.rendererStats.domElement);
    }

    this.camera = camera;
  }

  animate(delta) {
    this.blob.rotation.x -= delta * ROTA_X;

    this.blob.rotation.y += delta * ROTA_Y;

    this.blob.rotation.z += delta * ROTA_Z;
  }

  update(delta) {
    this.animate(delta);

    if (post === true) {
      PostProcessing.render();
    } else {
      renderer.render(scene, camera);
    }
  }

  postupdate() {
    if (this.rendererStats) {
      this.rendererStats.update();
    }
  }

  addEvents() {
    this.updateEvent = this.update.bind(this);
    emitter.on('update', this.updateEvent);

    this.postupdateEvent = this.postupdate.bind(this);
    emitter.on('postupdate', this.postupdateEvent);

    this.resizeEvent = this.resize.bind(this);
    emitter.on('resize', this.resizeEvent);
  }

  resize(w, h) {
    this.w = w;
    this.h = h;

    renderer.setSize(this.w, this.h);
  }
}
